import { useEffect, useState } from "react";

export const LOGO_URL = "/logos/LOGOTIPO.png";
export const LOGO_NEGATIVE_URL = "/logos/LOGOTIPO-NEGATIVO.png";
export const ISOTIPO_URL = "/logos/ISOTIPO.png";
export const AUDIOCODES_URL = "/logos/audiocodes.png";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NAV_LINKS = [
  { label: "Conector", hash: "conector" },
  { label: "Connect", to: "/connect" },
  { label: "Voice AI", to: "/voice-ai" },
  { label: "Insights", to: "/insights" },
  { label: "Contact Center", to: "/contact-center" },
  { label: "Nosotros", hash: "nosotros" },
  { label: "Contacto", hash: "contacto" },
];

export const PRODUCT_ROWS = [
  {
    name: "Caruna Connect",
    tech: "AudioCodes Live Multi-tenant",
    href: "/connect",
  },
  {
    name: "Caruna Voice AI",
    tech: "Live Hub / Voice AI Connect",
    href: "/voice-ai",
  },
  {
    name: "Caruna Insights",
    tech: "Interaction Insights",
    href: "/insights",
  },
  {
    name: "Caruna Meeting AI",
    tech: "Meeting Insights",
    href: "/meeting-ai",
  },
  {
    name: "Caruna Device Manager",
    tech: "IP Phone Manager / OVOC",
    href: "/device-manager",
  },
];

/* Pasos genéricos de implementación reutilizados por todas las páginas
 * de producto. Copy validado. */
export const DEFAULT_STEPS = [
  {
    title: "Diagnóstico inicial",
    desc: "Analizamos tu infraestructura actual, identificamos requerimientos técnicos y diseñamos un plan de migración a la medida de tu operación.",
  },
  {
    title: "Configuración y despliegue",
    desc: "Implementamos la plataforma junto con tu equipo, integramos con tus sistemas existentes y validamos cada flujo antes del go-live.",
  },
  {
    title: "Soporte continuo",
    desc: "Acompañamiento técnico permanente, monitoreo proactivo, actualizaciones y soporte especializado en español.",
  },
];

/* Plataformas UCaaS compatibles — mencionadas en copy aprobada del hero. */
export const DEFAULT_INTEGRATIONS = [
  "Microsoft Teams",
  "Zoom Phone",
  "Cisco Webex",
  "Google Voice",
];

export function useScrollReveal(key) {
  useEffect(() => {
    // Fresh setup on every route change: elements from the previous
    // page may have been unmounted while their observer was still alive.
    const els = document.querySelectorAll("[data-reveal]:not(.is-visible)");

    // Elements already in the viewport at mount get revealed immediately
    // so they never stay stuck at opacity 0.
    const viewportH = window.innerHeight || document.documentElement.clientHeight;
    els.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < viewportH && rect.bottom > 0) {
        el.classList.add("is-visible");
      }
    });

    const remaining = document.querySelectorAll(
      "[data-reveal]:not(.is-visible)",
    );
    if (remaining.length === 0) return undefined;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" },
    );
    remaining.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [key]);
}

export function useStickyNav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return scrolled;
}

export function useDocumentTitle(title) {
  useEffect(() => {
    if (!title) return undefined;
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}

export function scrollToHash(hash, offset = 72) {
  const id = hash?.replace(/^#/, "");
  if (!id) return;
  const el = document.getElementById(id);
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: "smooth" });
  }
}

/**
 * Navigate to a section on the home page.
 * If already on "/", smooth-scroll. Otherwise, full-page navigate to "/#hash"
 * — the HomePage will then scroll on mount.
 */
export function navigateToHomeSection(e, hash) {
  if (!hash) return;
  if (window.location.pathname === "/") {
    e.preventDefault();
    scrollToHash(hash);
  }
  // else: let the browser navigate to /#hash naturally
}

export function scrollToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}
